module.exports = __webpack_public_path__ + "static/media/icon-spotify.5cc85a03.svg";